import { render, staticRenderFns } from "./PackageEdit.vue?vue&type=template&id=0c360465&scoped=true&"
import script from "./PackageEdit.vue?vue&type=script&lang=ts&"
export * from "./PackageEdit.vue?vue&type=script&lang=ts&"
import style0 from "./PackageEdit.vue?vue&type=style&index=0&id=0c360465&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c360465",
  null
  
)

export default component.exports